"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cn = void 0;
const tailwind_merge_1 = require("tailwind-merge");
function toVal(mix) {
    let k, y, str = '';
    if (typeof mix === 'string' || typeof mix === 'number') {
        str += mix;
    }
    else if (typeof mix === 'object') {
        if (Array.isArray(mix)) {
            for (k = 0; k < mix.length; k++) {
                if (mix[k]) {
                    if ((y = toVal(mix[k]))) {
                        str && (str += ' ');
                        str += y;
                    }
                }
            }
        }
        else {
            for (k in mix) {
                if (mix[k]) {
                    str && (str += ' ');
                    str += k;
                }
            }
        }
    }
    return str;
}
const clsx = (...inputs) => {
    let i = 0, tmp, x, str = '';
    while (i < inputs.length) {
        if ((tmp = inputs[i++])) {
            if ((x = toVal(tmp))) {
                str && (str += ' ');
                str += x;
            }
        }
    }
    return str;
};
function cn(...inputs) {
    return (0, tailwind_merge_1.twMerge)(clsx(inputs));
}
exports.cn = cn;
